import { Button } from '@mui/material';
import { CtaLink } from '@repo/segment/components/CtaLink';
import { LinkType, type MonetizableEnum } from '@repo/segment/enums';
import { EntityPlacementCtaTypeEnum } from '@repo/supergraph/marketplace/enums';
import type { CtaType } from '@repo/supergraph/marketplace/types';

interface CtaComponentProps {
  cta: CtaType;
  monetizable: MonetizableEnum;
  offerId: string;
  text?: string;
}

export const CtaComponent: React.FC<CtaComponentProps> = ({ cta, monetizable, offerId, text }) => {
  if (!cta) {
    return null;
  }

  return (
    <CtaLink
      analyticsPayload={{ index: 0, offerId }}
      linkType={LinkType.APPLY_NOW_BUTTON}
      cta={{
        type: EntityPlacementCtaTypeEnum.ApplyNowButton,
        text: cta.text,
        link: cta.link,
        subtext: cta.subtext,
      }}
      Component={Button}
      monetizable={monetizable}
      sx={{
        textDecoration: 'none !important',
        width: { xs: '100%', md: '189px' },
        textAlign: 'center',
      }}
      data-testid="cta-button"
    >
      {text || cta.text}
    </CtaLink>
  );
};
